import HamMenu from "../../../Components/HamMenu/HamMenu";
import { languageElements } from './WarehouseHamMenu-languageElements';

export default function WarehouseHamMenu(props) {
    return (
        <HamMenu
            show={props.show}
            language={props.language}
            languageElements={languageElements}
            menuItems={
                [
                    { itemId: "warehouse-stocks", link: "/warehouse/stocks" },
                    { itemId: "warehouse-journal", link: "/warehouse/journal" }
                ]
            } />
    )
}
